import { PageHeader } from "components/ui";
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "components/buttonsComponent/StyledButton";
import NavigationButtons from "helper/navigation/NavigationButtons";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";

const WhatIsAA1000Series = () => {
  const urlConfig = {
    name: "AA1000Series.zip",
    downloadUrl: "https://demo.sustainesg.ca/pdf/AA1000Series.zip",
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="AA1000 Series"
            title={"AA1000 Series Reporting"}
            activeStep={0}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            top: "226px",
            left: "75px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#2E7D32",
              mb: 3,
              fontFamily: "DM Sans",
              fontSize: "40px",
              lineHeight: "38px",
            }}
          >
            The global standards for sustainability
            <br /> impacts
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography
              component="h4"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 800,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 1,
              }}
            >
              What is the AA1000 Series? — Brief introduction
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The AA1000 Series is a set of internationally recognized
              sustainability assurance and stakeholder engagement standards
              developed by AccountAbility, designed to help organizations
              improve accountability, sustainability performance, and
              stakeholder trust.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              It consists of three core frameworks:
            </Typography>
            <Box component="ul" sx={{ pl: 4, mb: 2 }}>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                AA1000 AccountAbility Principles Standard (AA1000APS) — defines
                the foundational principles organizations should apply for
                effective sustainability management and reporting, namely:
                <Box component="ul" sx={{ pl: 4 }}>
                  <Typography
                    component="li"
                    sx={{
                      fontFamily: "DM Sans",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "28px",
                      letterSpacing: "-2%",
                      color: "#4F4F4F",
                    }}
                  >
                    Inclusivity (engaging stakeholders in decisions that impact
                    them)
                  </Typography>
                  <Typography
                    component="li"
                    sx={{
                      fontFamily: "DM Sans",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "28px",
                      letterSpacing: "-2%",
                      color: "#4F4F4F",
                    }}
                  >
                    Materiality (focusing on what matters most)
                  </Typography>
                  <Typography
                    component="li"
                    sx={{
                      fontFamily: "DM Sans",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "28px",
                      letterSpacing: "-2%",
                      color: "#4F4F4F",
                    }}
                  >
                    Responsiveness (responding to stakeholder issues and
                    concerns)
                  </Typography>
                  <Typography
                    component="li"
                    sx={{
                      fontFamily: "DM Sans",
                      fontWeight: 400,
                      fontSize: "20px",
                      lineHeight: "28px",
                      letterSpacing: "-2%",
                      color: "#4F4F4F",
                    }}
                  >
                    Impact (understanding and communicating impacts on
                    sustainability)
                  </Typography>
                </Box>
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                AA1000 Assurance Standard (AA1000AS) — provides a framework for
                independent third-party assurance of sustainability reports,
                verifying the quality, completeness, and credibility of
                sustainability information and adherence to the AA1000
                principles
              </Typography>
              <Typography
                component="li"
                sx={{
                  fontFamily: "DM Sans",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "28px",
                  letterSpacing: "-2%",
                  color: "#4F4F4F",
                }}
              >
                AA1000 Stakeholder Engagement Standard (AA1000SES) — offers a
                detailed methodology for conducting structured, meaningful, and
                effective stakeholder engagement, helping organizations
                integrate stakeholder views into governance, strategy, and
                performance
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "DM Sans",
                fontWeight: 400,
                fontSize: "20px",
                lineHeight: "28px",
                letterSpacing: "-2%",
                color: "#4F4F4F",
                mb: 2,
              }}
            >
              The AA1000 Series helps companies strengthen governance, align
              sustainability efforts with stakeholder expectations, improve
              transparency, and build long-term trust through credible reporting
              and assurance practices. It is widely used alongside frameworks
              like GRI, TCFD, and the UN Global Compact.
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* <a
            href="https://www.accountability.org/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <CustomButton title="Access Full AA1000 Series Documentation" />
          </a> */}

          <DownloadZipButton
            config={urlConfig}
            title="Access Full AA1000 Series Documentation"
            externalHref="https://www.accountability.org/"
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default WhatIsAA1000Series;
